import { Button, Collapsible, Link, Stack, Text } from '@chakra-ui/react';
import { NavArrowDown } from 'iconoir-react';
import { Trans, useTranslation } from 'react-i18next';

/** Shared disclosure shown before Gmail and Drive authorization, and when connected. */
const GoogleDataUseNotice = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <Collapsible.Root>
      <Collapsible.Trigger asChild>
        <Button
          variant="plain"
          size="sm"
          px={0}
          h="auto"
          color="fg.muted"
          fontWeight="medium"
          gap={2}
          _open={{ '& svg': { transform: 'rotate(180deg)' } }}
        >
          {t('integrations.googleDataUse.title')}
          <NavArrowDown width={14} height={14} aria-hidden="true" />
        </Button>
      </Collapsible.Trigger>
      <Collapsible.Content pt={3}>
        <Stack gap={2} fontSize="sm" color="fg.muted">
          <Text>
            <Trans
              i18nKey="integrations.googleDataUse.limitedUse"
              components={{
                policy: (
                  <Link
                    href="https://developers.google.com/terms/api-services-user-data-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="underline"
                  />
                ),
              }}
            />
          </Text>
          <Text>{t('integrations.googleDataUse.noTraining')}</Text>
          <Link
            href={`https://www.fluenceur.com/${locale}/privacy-policy`}
            target="_blank"
            rel="noopener noreferrer"
            variant="underline"
          >
            {t('integrations.googleDataUse.privacyLink')}
          </Link>
        </Stack>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

export default GoogleDataUseNotice;
